// src/lib/format.js

/** Kwota po polsku: 149 zł, 12,71 zł - bez zbędnych zer po przecinku. */
export const formatPln = value => {
  const amount = Number(value) || 0;
  const hasFraction = Math.round(amount * 100) % 100 !== 0;
  return `${amount.toFixed(hasFraction ? 2 : 0).replace('.', ',')} zł`;
};
